<template>
  <v-row no-gutters class="text-caption mr-3">
    <v-col cols="6" class="text-body-2 font-weight-bold primary--text">
      <v-icon
        left
        small
        :color="active ? 'primary' : 'grey darken-1'"
        v-text="icons.history"
      />
      #{{ order.id }}
    </v-col>
    <v-col cols="6" class="font-weight-bold text-right">
      <v-icon left small v-text="icons.coins" />
      {{ order.total | currency }}
    </v-col>
    <h-header-item icon="table" :active="active">
      <b>{{ order.tableName }}</b>
      {{ order.guests | guests }}
    </h-header-item>
    <h-header-item icon="user" :active="active">
      {{ order.tenantUserName }}
    </h-header-item>
    <h-header-item icon="calendar" :active="active" v-if="showDate">
      {{ order.openedMoment.format('L') }}
    </h-header-item>
    <h-header-item icon="clock" :active="active">
      {{ order.openedMoment.format('H:mm') }}h. - {{ order.closedMoment.format('H:mm') }}h.
      {{ order.closedMoment.diff(order.openedMoment) | duration }}
    </h-header-item>
  </v-row>
</template>

<script>
  import moment from 'moment'
  import Currenciable from '@/Mixins/Currenciable'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HHeaderItem from './HeaderItem'

  export default {
    mixins: [
      Currenciable,
      UsesIcons,
    ],

    components: {
      HHeaderItem,
    },

    props: {
      order: {
        required: true,
        type: Object,
      },
      active: {
        required: true,
        type: Boolean,
      },
      showDate: {
        required: true,
        type: Boolean,
      },
    },

    filters: {
      guests: v => {
        if (v === 0) {
          return ''
        }
        return v > 0 ? `(x${v})` : `(${v})`
      },
      duration: milliseconds => {
        const localize = (value, unit) => moment.localeData().relativeTime(value, true, unit)

        const seconds = Math.round(milliseconds / 1000)
        if (seconds < 2) {
          return ''
        }
        if (seconds < 60) {
          return `(${localize(seconds, 'ss')})`
        }

        const minutes = Math.round(seconds / 60)
        if (minutes < 60) {
          return `(${localize(minutes, 'mm')})`
        }
        if (minutes < 120) {
          return `(${localize(1, 'h')} ${localize(minutes - 60, 'mm')})`
        }

        const hours = Math.round(minutes / 60)

        return `(${localize(hours, 'hh')})`
      },
    },
  }
</script>
